const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * EQUALWEB (ACCESSIBILITY) EVENTS                                            *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.accessibilityIconClicked,
    (payload) => {
      pushEvent(
        createCustomEventGA4('accesibility', [
          ['item', payload.pageType],
          ['action', payload.action],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
